// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.apply-container {
  background: url('https://images.unsplash.com/photo-1591696205602-2f950c417cb9?auto=format&fit=crop&w=1600&q=80') no-repeat center center/cover;
  min-height: 100vh;
  padding: 2rem;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}


.apply-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65); /* dark overlay */
  z-index: 1;
}

.apply-container > * {
  position: relative;
  z-index: 2;
}

.apply-container h1, .myh2class{
  font-size: 3rem;
  margin-bottom: 1.5rem;
  text-shadow: 2px 2px 6px black;
}

.card-section {
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.apply-card {
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid #017f57;
  border-radius: 12px;
  padding: 1.5rem;
  width: 280px;
  cursor: pointer;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s;
  color: white;
}

.apply-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);
  background-color: rgba(255, 255, 255, 0.2);
}

.apply-card h3 {
  font-size: 1.4rem;
  color: #90caf9;
  margin-bottom: 0.5rem;
}

.note-box {
  background: #fffbe6;
  color: #333;
  padding: 1rem;
  border-left: 6px solid #017f57;
  margin: 2rem auto;
  border-radius: 8px;
  max-width: 600px;
  text-align: left;
  font-size: 0.95rem;
}

.pdf-section {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.pdf-button {
  background-color: #017f57;
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.pdf-button:hover {
  background-color: #017f57;
}

.next-steps {
  margin-top: 3rem;
  padding-top: 1rem;
  border-top: 1px solid #666;
}

.next-steps h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.next-steps ul {
  list-style: none;
  padding-left: 0;
  line-height: 1.8;
}

.next-steps a {
  color: #4dd0e1;
  text-decoration: underline;
}


/* Responsive Media Queries */
@media (max-width: 1024px) {
  body, .container {
    padding: 1rem;
    font-size: 1rem;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 600px) {
  .container, .card, .section, .content {
    flex-direction: column !important;
    width: 100% !important;
    font-size: 0.9rem !important;
    padding: 0.5rem !important;
  }

  h1, h2, h3 {
    font-size: 1.2rem !important;
  }

  nav, header, footer {
    flex-direction: column;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Apply.css"],"names":[],"mappings":";AACA;EACE,8IAA8I;EAC9I,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B,EAAE,iBAAiB;EAClD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,4EAA4E;EAC5E,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;;AAGA,6BAA6B;AAC7B;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF","sourcesContent":["\n.apply-container {\n  background: url('https://images.unsplash.com/photo-1591696205602-2f950c417cb9?auto=format&fit=crop&w=1600&q=80') no-repeat center center/cover;\n  min-height: 100vh;\n  padding: 2rem;\n  color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n\n.apply-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.65); /* dark overlay */\n  z-index: 1;\n}\n\n.apply-container > * {\n  position: relative;\n  z-index: 2;\n}\n\n.apply-container h1, .myh2class{\n  font-size: 3rem;\n  margin-bottom: 1.5rem;\n  text-shadow: 2px 2px 6px black;\n}\n\n.card-section {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  margin: 2rem 0;\n  flex-wrap: wrap;\n}\n\n.apply-card {\n  background: rgba(255, 255, 255, 0.1);\n  border: 2px solid #017f57;\n  border-radius: 12px;\n  padding: 1.5rem;\n  width: 280px;\n  cursor: pointer;\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s;\n  color: white;\n}\n\n.apply-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.apply-card h3 {\n  font-size: 1.4rem;\n  color: #90caf9;\n  margin-bottom: 0.5rem;\n}\n\n.note-box {\n  background: #fffbe6;\n  color: #333;\n  padding: 1rem;\n  border-left: 6px solid #017f57;\n  margin: 2rem auto;\n  border-radius: 8px;\n  max-width: 600px;\n  text-align: left;\n  font-size: 0.95rem;\n}\n\n.pdf-section {\n  display: flex;\n  justify-content: center;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n.pdf-button {\n  background-color: #017f57;\n  color: white;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  text-decoration: none;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n}\n\n.pdf-button:hover {\n  background-color: #017f57;\n}\n\n.next-steps {\n  margin-top: 3rem;\n  padding-top: 1rem;\n  border-top: 1px solid #666;\n}\n\n.next-steps h2 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.next-steps ul {\n  list-style: none;\n  padding-left: 0;\n  line-height: 1.8;\n}\n\n.next-steps a {\n  color: #4dd0e1;\n  text-decoration: underline;\n}\n\n\n/* Responsive Media Queries */\n@media (max-width: 1024px) {\n  body, .container {\n    padding: 1rem;\n    font-size: 1rem;\n  }\n  img, video {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .container, .card, .section, .content {\n    flex-direction: column !important;\n    width: 100% !important;\n    font-size: 0.9rem !important;\n    padding: 0.5rem !important;\n  }\n\n  h1, h2, h3 {\n    font-size: 1.2rem !important;\n  }\n\n  nav, header, footer {\n    flex-direction: column;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
